import { MessagingHubHttpClient } from "@/services/messaging-hub-http-client";

export type DocumentSendChannel = "email" | "whatsapp";

export interface DocumentSendInbox {
  id: number;
  name: string;
  address: string | null;
}

export interface DocumentSendConversation {
  id: string;
  inboxId: number;
  inboxName: string;
  status: string;
  subject: string | null;
  contactName: string | null;
  address: string | null;
  lastActivityAt: string | null;
}

export interface DocumentSendChannelOptions {
  available: boolean;
  inboxes: DocumentSendInbox[];
  conversations: DocumentSendConversation[];
}

export type DocumentSendOptions = Record<DocumentSendChannel, DocumentSendChannelOptions> & {
  /** The user can access at least one FrontDesk inbox, whether or not it reaches this contact. */
  hasInboxes?: boolean;
};

export interface CreateDocumentConversationParams {
  channel: DocumentSendChannel;
  inboxId: number;
  email?: string;
  phone?: string;
  contactName?: string;
  subject?: string;
  customerId?: string;
}

/** Sending a GoMake document through FrontDesk when it is not linked to a conversation yet. */
export class FrontDeskDocumentSendService extends MessagingHubHttpClient {
  getOptions(contact: { email?: string; phone?: string }): Promise<DocumentSendOptions> {
    return this.post<DocumentSendOptions>("/frontdesk/document-send/options", contact);
  }

  createConversation(
    params: CreateDocumentConversationParams
  ): Promise<{ conversationId: string; created: boolean }> {
    return this.post("/frontdesk/document-send/conversations", params);
  }
}

let instance: FrontDeskDocumentSendService | null = null;

/** Lazily created so the client's base-URL resolution runs in the browser. */
export const getFrontDeskDocumentSendService = (): FrontDeskDocumentSendService => {
  if (!instance) instance = new FrontDeskDocumentSendService();
  return instance;
};
